import { writable } from "svelte/store";

export let mpTableFilter = writable(null);